import { render, staticRenderFns } from "./Acl.vue?vue&type=template&id=244207de"
import script from "./Acl.vue?vue&type=script&lang=js"
export * from "./Acl.vue?vue&type=script&lang=js"
import style0 from "./Acl.vue?vue&type=style&index=0&id=244207de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports